import styled from "styled-components";

export const ContentSection = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 2em;
`;

export const ViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2rem;
  padding: 1.5rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const SectionContent = styled.p`
  font-size: 1rem;
  width: 90%;
  color: #555;
  white-space: pre-wrap;
`;

export const ButtonCity = styled.button`
  padding: 0.2rem;
  background-color: ${(props) =>
    props.type === "delete" ? "#f44336" : props.ativo ? "#4CAF50" : "#c2c2c2"};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.type === "delete"
        ? "#e53935"
        : props.ativo
          ? "#3d903f"
          : "#a7a7a7"};
  }
`;
